import { IconButton, Stack, Badge, Popover, Box, TextField } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useState } from "react";


export default function DataInicioFimFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const onClose = () => {
    setAnchorEl(null);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props?.dataInicio || !props?.dataFim}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>
        <TextField
            style={{ width: 200, marginBottom: 10 }}
            type="date"
            fullWidth
            label="Data Inicial"
            size="small"
            name="dataInicial"
            variant="outlined"
            onChange={(e) => props.setDataInicio(e.target.value)}
            value={props.dataInicio}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <br />
          <TextField
            style={{ width: 200 }}
            type="date"
            fullWidth
            label="Data Final"
            size="small"
            name="dataFinal"
            variant="outlined"
            onChange={(e) => props.setDataFim(e.target.value)}
            value={props.dataFim}
            InputLabelProps={{
              shrink: true,
            }}
          />

          {/* <TextField
            select
            label={'Mês'}
            value={props?.selectedMonth}
            onChange={(e) => props?.setSelectedMonth(parseInt(e.target.value))}
            fullWidth
            variant="outlined"
            size="small"
          >
            {generateMonthOptions()?.map((option, index) => (
              <MenuItem key={index} value={option?.value}>
                {option?.label}
              </MenuItem>
            ))}
          </TextField>
          <br />
          <TextField
            select
            label={'Ano'}
            margin="normal"
            value={props?.selectedYear}
            onChange={(e) => props?.setSelectedYear(parseInt(e.target.value))}
            fullWidth
            variant="outlined"
            size="small"
          >
            {generateYearOptions()?.map((option, index) => (
              <MenuItem key={index} value={option?.value}>
                {option?.label}
              </MenuItem>
            ))}
          </TextField> */}

        </Box>
      </Popover>
    </Stack>
  );
};


